var styles = {"fontElementMap":"rdEOR","orderedlist":"_9dQCG","bulletedlist":"_9IweU","listItem":"Ojm1O"};

export { styles as s };
//# sourceMappingURL=lists-05124ec3.js.map
